import { useKindeAuth } from '@kinde-oss/kinde-auth-react'
import ls from 'localstorage-slim'
import { Building, HelpCircle, LogOut, Moon, Sun, Users } from 'lucide-react'

import { Role, Theme } from '@ankor-io/common/types/account'
import { updateThemeMode } from '@ankor-io/common/util/updateThemeMode'

import { useUserContext } from '@/providers/user/useUserContext'
import { AvatarButton } from '@/ui-components/Avatar'
import { DropdownButton, DropdownDivider, DropdownHeader, DropdownItem, DropdownMenu } from '@/ui-components/Dropdown'
import { Dropdown } from '@/ui-components/Dropdown'

// TODO
// import UserProfileModal from '@/views/components/UserProfileModal'

export const UserAvatarMenu = ({
  setIsOrganizationsModalOpen,
}: {
  setIsOrganizationsModalOpen: (isOpen: boolean) => void
}) => {
  // const [isProfileModalOpen, setIsProfileModalOpen] = useState(false)
  // const [userAvatar, setUserAvatar] = useState('🐼') // Default avatar
  const { updatePreferences, activeOrganizationId, organizations, user } = useUserContext()
  const { logout } = useKindeAuth()

  // Get user's full name
  const getUserFullName = () => {
    if (!user) {
      return ''
    }
    const { givenName, familyName } = user
    if (givenName && familyName) {
      return `${givenName} ${familyName}`
    }
    return givenName || familyName
  }

  return (
    <>
      <Dropdown>
        <DropdownButton
          as={AvatarButton}
          className="size-8 cursor-pointer hover:ring-2 hover:ring-white/50 transition-all"
          initials={user ? `${user?.givenName?.charAt(0)}${user?.familyName?.charAt(0)}` : ''}
          alt="Profile avatar"
          data-testid="avatar-button"
        ></DropdownButton>
        <DropdownMenu anchor="bottom end">
          <DropdownHeader className="font-medium text-gray-900 dark:text-white">{getUserFullName()}</DropdownHeader>
          <DropdownDivider />
          {/* <DropdownItem onClick={() => setIsProfileModalOpen(true)}>
            <User className="mr-2 size-4" />
            My Profile
          </DropdownItem> */}
          <DropdownItem onClick={() => setIsOrganizationsModalOpen(true)}>
            <Building className="mr-2 size-4" />
            Organizations
          </DropdownItem>
          {activeOrganizationId &&
            (organizations[activeOrganizationId]?.roles.includes(Role.ADMIN) ||
              organizations[activeOrganizationId]?.roles.includes(Role.OWNER)) && (
              <DropdownItem to="/users">
                <Users className="mr-2 size-4" />
                Organization Users
              </DropdownItem>
            )}
          <DropdownDivider />
          <DropdownItem
            to="https://ankorsoftware.productfruits.help"
            target="_blank"
          >
            <HelpCircle className="mr-2 size-4" />
            Support
          </DropdownItem>
          {ls.get('prefers-color-scheme') === Theme.DARK ? (
            <DropdownItem
              onClick={() => {
                updateThemeMode(Theme.LIGHT)
                updatePreferences({ theme: Theme.LIGHT })
              }}
            >
              <Sun className="mr-2 size-4" />
              Light Mode
            </DropdownItem>
          ) : (
            <DropdownItem
              onClick={() => {
                updateThemeMode(Theme.DARK)
                updatePreferences({ theme: Theme.DARK })
              }}
            >
              <Moon className="mr-2 size-4" />
              Dark Mode
            </DropdownItem>
          )}
          <DropdownItem onClick={() => logout()}>
            <LogOut className="mr-2 size-4" />
            Logout
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      {/* <UserProfileModal
        isOpen={isProfileModalOpen}
        onClose={() => setIsProfileModalOpen(false)}
        currentAvatar={userAvatar}
        onAvatarChange={setUserAvatar}
      /> */}
    </>
  )
}

export default UserAvatarMenu
